document.addEventListener("DOMContentLoaded", function(){

  const root = document.querySelector(".hf-box-finder");

  if(!root){
    return;
  }

  const buttons = root.querySelectorAll(".hf-industry-list button");
  const panels = root.querySelectorAll(".hf-recommend-panel");


  buttons.forEach(function(button){

    button.addEventListener("click",function(){

      const industry = this.dataset.industry;


      buttons.forEach(function(btn){
        btn.classList.remove("active");
      });


      panels.forEach(function(panel){
        panel.classList.remove("active");
      });


      this.classList.add("active");


      const target = root.querySelector(
        '.hf-recommend-panel[data-panel="' + industry + '"]'
      );


      if(target){
        target.classList.add("active");
      }

    });

  });

});